<template>
  <el-tabs type="border-card" class="data-source-manage" @tab-click="switchTab" tab-position="left">
    <el-tab-pane label="RDB">
      <span slot="label"><i class="el-icon-tickets"></i> RDB数据源</span>
      <keep-alive>
        <rdb-data-source v-if="label === 'RDB'"></rdb-data-source>
      </keep-alive>
    </el-tab-pane>
    <el-tab-pane label="API">
      <span slot="label"><i class="el-icon-upload"></i> API数据源</span>
      <keep-alive>
        <api-data-source v-if="label === 'API'"></api-data-source>
      </keep-alive>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import RdbDataSource from './RdbDataSource'
import ApiDataSource from './ApiDataSource'

export default {
  name: 'data-source-manage',
  components: {
    RdbDataSource,
    ApiDataSource
  },
  data () {
    return {
      label: 'RDB'
    }
  },
  methods: {
    switchTab (panel) {
      this.label = panel.label
    }
  }
}
</script>

<style>
.data-source-manage{height:600px;}
.data-source-manage.el-tabs--border-card{border:none;box-shadow:none;}
.data-source-manage .el-tabs__content{padding:0;}
.data-source-manage.el-tabs--left .el-tabs__header.is-left{margin-right:0;}
.data-source-manage.el-tabs--border-card>.el-tabs__content{padding:0;}
</style>